import React, { Component } from 'react';
import { FormGroup, ControlLabel, Col, FormControl, HelpBlock } from 'react-bootstrap';
import { RadioGroup } from '../common';
import moment from 'moment';

export default class DateRadioField extends Component {

  constructor(props) {
    super(props);
    this.state = {
      previewText: this.updatePreviewBox(props.input.value || props.defaultValue)
    }
  }

	componentDidMount() {
   const { input, defaultValue } = this.props;
   if (defaultValue && !input.value) input.onChange(defaultValue);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({previewText: this.updatePreviewBox(nextProps.input.value)})
  }

  updatePreviewBox(value) {
    let selectedTime;
    switch(value) {
      case 'relative':
        selectedTime = `about ${moment().subtract(2, 'days').fromNow()}`;
        break;
      case 'long':
        selectedTime = moment().subtract(2, 'days').format("MMMM D, YYYY");
        break;
      case 'iso8601':
        selectedTime = moment().subtract(2, 'days').format('YYYY/MM/DD');
        break;
      case 'MM/DD/YYYY':
        selectedTime = moment().subtract(2, 'days').format('MM/DD/YYYY');
        break;
      case 'MM/DD/YY':
        selectedTime = moment().subtract(2, 'days').format('MM/DD/YY');
				break;
			case 'DD/MM/YYYY':
				selectedTime = moment().subtract(2, 'days').format('DD/MM/YYYY');
      default:
        selectedTime = moment().subtract(2, 'days').format(value);
    }
    return selectedTime;
  }

	render() {
		const {
			input,
			meta: { error, touched },
			label,
			defaultValue,
			id,
			layout,
			disabled,
			options
		} = this.props;

    let { previewText } = this.state;
		const showError = error && touched;
		const inputBlock = () => {
			return (
				<div>
					<RadioGroup
						name={input.name}
						onChange={input.onChange}
						options={options}
						value={input.value || defaultValue}
						disabled={disabled}
					/>
					<FormControl.Feedback />
					<HelpBlock>{showError ? error : ''}</HelpBlock>
				</div>
			);
		};

		if (layout === 'horizontal') {
			return (
				<FormGroup controlId={id || input.name} validationState={showError ? 'error' : null}>
					<Col componentClass={ControlLabel} xs={3} className="control-label-horizontal">
						{label}
					</Col>
					<Col xs={9}>
						{inputBlock()}
					</Col>
				</FormGroup>
			);
		}

		return (
			<FormGroup
				controlId={id || input.name}
				className={label ? 'label-present' : 'label-blank'}
				validationState={showError ? 'error' : null}
			>
				{label ? <ControlLabel>{label}</ControlLabel> : ''}
        <div className="preview-box text-center center-block">
					<p>{previewText}</p>
        </div>
				{inputBlock()}
			</FormGroup>
		);
	}
}
